import React, { useMemo } from 'react';
import { Typography } from 'antd';

import { enviroment } from '@utils/config';
import LoginForm from '@pages/Login/containers/LoginForm';

// import logoCompuestoCelsia from '@assets/img/logo/logo_compuesto_orange.png';
import logoCompuestoCelsia from '@assets/img/logo/LogoCelsiaBlanco.png';
import logoCompuestoMubon from '@assets/img/logo/mubon_compuesto.png';

import withNotAuth from '@common/hocs/withNotAuth';
import SelectLanguage from '@common/containers/Header/SelectLanguage';

import styles from './Login.module.less';

const { Title, Paragraph } = Typography;

function Login() {

  const values = useMemo(() => {

    const { platform } = enviroment;
    const dicValues = {
      mubon: {
        logo: logoCompuestoMubon,
        name: 'Mubon Flotas EV',
        copy:
          '© Copyright 2021 Mubon smart mobility solution for electric vehicles | Desarrollado por DeepSea Developments',
      },
      celsia: {
        logo: logoCompuestoCelsia,
        name: 'Celsia IotBox',
        copy: '© Copyright 2021 Celsia S.A. E.S.P. - Medellín, Colombia',
      },
    };
    return dicValues[platform] || dicValues.celsia;

  }, []);

  const { logo, name, copy } = values;

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <section>
          <header>
            <img width={240} src={logo} alt={`Logo ${name}`} />
          </header>
          <Title className={`${styles.title} primary_color2`} level={4}>
            {name}
          </Title>
          <LoginForm />
        </section>
        <footer>
          <Paragraph>{copy}</Paragraph>
        </footer>
      </div>
      <SelectLanguage className={styles.select_language} />
    </div>
  );

}

export default withNotAuth(Login);
